import { toBlob } from "html-to-image";
import { inlineComputedSvgStyles } from "./svgStyles";
import { snapshotWebGLCanvases } from "./webglCanvases";

// transparent 1x1 gif, used for images that can't be fetched (e.g. cross-origin without CORS)
const IMAGE_PLACEHOLDER = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

/**
 * Captures the visible part of the page as a JPEG. Returns undefined when the capture fails, the
 * help request is then sent without screenshot. WebGL canvases not registered with
 * registerCapturableCanvas come out blank.
 */
export const captureScreenshot = async (): Promise<Blob | undefined> => {
  // waits until the pending ui changes (e.g. a menu closing) are painted
  await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

  const root = document.body;
  const restoreStyles = inlineComputedSvgStyles(root);
  const restoreCanvases = snapshotWebGLCanvases(root);

  try {
    const blob = await toBlob(root, {
      type: "image/jpeg",
      quality: 0.8,
      pixelRatio: 1,
      backgroundColor: "#ffffff",
      imagePlaceholder: IMAGE_PLACEHOLDER,
      width: window.innerWidth,
      height: window.innerHeight,
      // crops the body to the scrolled viewport
      style: { transform: `translate(${-window.scrollX}px, ${-window.scrollY}px)` },
    });
    return blob ?? undefined;
  } catch {
    return undefined;
  } finally {
    restoreStyles();
    restoreCanvases();
  }
};
